/*
 * Copyright (C) 2025. Archimedes Exhibitions GmbH,
 * Saarbrücker Str. 24, Berlin, Germany
 *
 * This file contains proprietary source code and confidential
 * information. Its contents may not be disclosed or distributed to
 * third parties unless prior specific permission by Archimedes
 * Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
 * to copies made in any form and using any medium. It applies to
 * partial as well as complete copies.
 */

function secondsToHHMMSS (sec) {
  let hours = Math.floor(sec / 3600)
  let minutes = Math.floor((sec - (hours * 3600)) / 60)
  let seconds = Math.floor((sec - (hours * 3600)) - (minutes * 3600) / 60)

  if (hours < 10) hours = '0' + hours
  if (minutes < 10) minutes = '0' + minutes
  if (seconds < 10) seconds = '0' + seconds

  return hours + ':' + minutes + ':' + seconds
}

function timeToSeconds (time) {
  if (time.length < 6) time += ':00'
  let t = time.split(':')
  return (+t[0]) * 60 * 60 + (+t[1]) * 60 + (+t[2])
}

function sleep (milliseconds) {
   return new Promise(resolve => setTimeout(resolve, milliseconds))
}

function captalize (s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export { secondsToHHMMSS, timeToSeconds, sleep, captalize }
